import copyToClipboard from "@/common/utils/copy-to-clipboard";
import { Button } from "@nextui-org/react";
import { MdOutlineClose } from "react-icons/md";
import { toast } from "sonner";

const successClass = 'font-bold text-white border-0 shadow-sm bg-gradient-to-br from-emerald-500 to-emerald-700';
const infoClass = 'font-bold text-teal-700 border-0 shadow-sm bg-gradient-to-br from-teal-200 to-teal-500';
const errorClass = 'font-bold text-white border-0 shadow-sm bg-gradient-to-br from-rose-400 to-rose-500';
const warningClass = 'font-bold text-amber-700 border-0 shadow-sm bg-gradient-to-br from-amber-200 to-yellow-500';

const custom = (
	heading: 'Success' | 'Error' | 'Info' | 'Warning',
	classes: typeof successClass | typeof errorClass | typeof infoClass | typeof warningClass,
	message: string,
	duration: number = 3000
) => {
	 toast((
		<div className="flex flex-col gap-1">
			<div className="text-base font-medium">{heading}</div>
			<p className="mb-0 text-sm font-normal">{message}</p>
		</div>
	), {
		className: classes,
		duration,
		position: 'top-right',
		// closeButton: true
	});
};

const customFlashMessage = (
	heading: 'Success' | 'Error' | 'Info' | 'Warning',
	classes: typeof successClass | typeof errorClass | typeof infoClass | typeof warningClass,
	message: string,
	data?: any,
	duration: number = 2500,
) => {
	toast.custom((toastData) => (
		<>
			<div className="flex items-center justify-between" style={{marginTop: '-0.5rem'}}>
				<span className="text-base font-medium">{heading}</span>
				<Button
					className="text-white bg-transparent hover:!bg-transparent border-0 text-base"
					size="sm"
					variant="ghost"
					color="danger"
					isIconOnly
					onClick={() => toast.dismiss(toastData)}
				>
					<MdOutlineClose />
				</Button>
			</div>
			<p className="mb-0 text-sm font-normal whitespace-pre-line">{message}</p>
			{
				data && (
					<Button
						variant="flat"
						size="sm"
						radius="sm"
						className="inline-flex mt-3 mr-auto text-white"
						onClick={() => copyToClipboard(JSON.stringify(data, null, 2))}
					>
						Copy to Clipboard
					</Button>
				)
			}
		</>
	), {
		className: classes + " w-80 p-4 text-sm flex flex-col rounded-lg",
		duration,
		position: 'top-right',
	});
 };
const success = (message: string) => { customFlashMessage('Success', successClass, message) };
const error = (message: string, data?: any) => { customFlashMessage('Error', errorClass, message, data, 6000) };
const info = (message: string) => { customFlashMessage('Info', infoClass, message) };
const warning = (message: string) => { customFlashMessage('Warning', warningClass, message) };

export { error, info, success, warning };
